import PullQuote from './container.js'
export default PullQuote
